var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBulb = function SvgBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M16.55 35.7h9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.8,
    d: "M31.683 10.947c.57 1.355.863 2.81.863 4.279a10.96 10.96 0 0 1-4.425 8.835 5.1 5.1 0 0 0-1.364 1.535c-.185.32-.333 1.32-.444 2.288-.13 1.134-1.063 1.991-2.204 1.991h-5.183c-1.13 0-2.053-.84-2.185-1.962-.116-.98-.269-2-.458-2.324a5.2 5.2 0 0 0-1.374-1.545 10.93 10.93 0 0 1-4.409-8.753c-.032-5.966 4.798-10.942 10.764-11.088a11.02 11.02 0 0 1 10.419 6.744Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M27.8 12.83a6.81 6.81 0 0 0-3.782-3.696"
  })));
};
export default SvgBulb;